import { getFormattedDurationShort } from '../../../../../common/duration'
import React from 'react'
import { CrossClientQueryExecution } from '../../../../../models/CrossClient'

export interface CrossClientQueryFinishedProps {
  execution: CrossClientQueryExecution
}
export const CrossClientQueryFinishedInfo: React.FC<CrossClientQueryFinishedProps> = ({ execution }) => {
  if (!execution.startedAt || !execution.finishedAt) {
    return null
  }

  return (
    <div className='d-flex flex-column gap-2'>
      <div className='paragraph-small zocks-text-gray-700'>Ran for {getFormattedDurationShort(execution.startedAt, execution.finishedAt)}</div>
    </div>
  )
}
